import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface LayersState {
  selectedLayers: number[]
  buttonState: Record<number, { value: number[]; checkedCount: number }>
  markersCleared: boolean
}

const initialState: LayersState = {
  selectedLayers: [],
  buttonState: {},
  markersCleared: false,
}

export const layersSlice = createSlice({
  name: 'layers',
  initialState,
  reducers: {
    addSelectedLayers(state, action: PayloadAction<number>) {
      state.selectedLayers.push(action.payload)
    },
    removeSelectedLayers(state, action: PayloadAction<number>) {
      state.selectedLayers = state.selectedLayers.filter(
        (el) => el !== action.payload
      )
    },
    setButtonState(
      state,
      action: PayloadAction<{ layerId: number; value: number[] }>
    ) {
      const { layerId, value } = action.payload
      const checkedCount = value.reduce(
        (count, id) => (state.selectedLayers.includes(id) ? count + 1 : count),
        0
      )
      state.buttonState[layerId] = { value, checkedCount }
    },
    setMarkersCleared(state, action: PayloadAction<boolean>) {
      state.markersCleared = action.payload
    },
  },
})

export const layersActions = layersSlice.actions
export const layersReducer = layersSlice.reducer
